import { DUMMY_SKU_LITA } from './constants'

export const isDummyLitaProduct = product => {
  if (!DUMMY_SKU_LITA) return false

  return (
    product?.Sku === DUMMY_SKU_LITA ||
    product?.SystemCode === DUMMY_SKU_LITA ||
    product?.referencia === DUMMY_SKU_LITA
  )
}
